
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    // Use MediaQueryList API for better performance
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    // Modern browsers use addEventListener
    const handleChange = () => checkIsMobile()
    mql.addEventListener("change", handleChange)
    
    // Check immediately on mount
    checkIsMobile()
    
    return () => mql.removeEventListener("change", handleChange)
  }, [])

  // Default to false if undefined (for SSR)
  return isMobile === undefined ? false : isMobile
}

// Add an alias for backward compatibility
export const useMobile = () => {
  const isMobile = useIsMobile();
  return { isMobile };
};
